import styled from 'styled-components';

import FormGroup from '@mui/material/FormGroup';

import { reemaColors } from 'toolkit/styles/colors';
import HtmlDisplayer from '../components/HtmlDisplayer';
import { HorizontalRule } from '../dialog/DialogStyledComponents';

export const Section = styled.div`
  margin: 8px 0 24px;
`;

export const SectionContainer = styled.div`
  margin-bottom: 35px;
`;

export const SectionHeader = styled.div`
  margin-bottom: 12px;
  font-family: 'Inclusive Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: #191c1d;
`;

export const ContentHeader = styled.div`
  margin-bottom: 10px;
  font-family: 'Inclusive Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: #40484b;
`;

export const ContentBody = styled.div`
  font-family: 'Inclusive Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: -0.15px;
  color: #40484b;
`;

export const HTMLWrapper = styled(HtmlDisplayer)`
  font-family: 'Inclusive Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: -0.15px;
  color: #40484b;
`;

export const LightenedRule = styled(HorizontalRule)`
  margin: 5px auto;
  width: 95%;
`;

export const NumberedSectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-self: stretch;
  align-items: flex-start;
  gap: 12px;
  padding: 24px;
  border-radius: 16px;
  background: linear-gradient(
      0deg,
      rgba(0, 103, 128, 0.05) 0%,
      rgba(0, 103, 128, 0.05) 100%
    ),
    ${reemaColors.lightBackground};

  p {
    padding: 0;
    margin: 0;
  }
`;

export const NumberedHeader = styled(ContentHeader)`
  margin-bottom: 0;
  line-height: 24px;
`;

export const NumberedContentBody = styled(ContentBody)`
  padding: 0;
  margin-bottom: 16px;
`;

export const NumberedHTMLWrapper = styled(HTMLWrapper)`
  padding: 0;
`;

export const DescriptionContainer = styled.div`
  margin: 24px 0;
  font-family: 'Inclusive Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: #40484b;
`;

export const ToggleFormGroup = styled(FormGroup)`
  margin-bottom: 32px;
`;

export const EventFieldsContainer = styled.div`
  margin: 32px 0;
`;

export const EventContainer = styled.div`
  p {
    font-family: 'Inclusive Sans';
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: -0.05px;
    color: #191c1d;
  }
`;
